import { errorValidation } from './utils';

/**
 * Validate forms
 */
(() => {
	// Login Email
	$("form[name='login_email']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'login_email[email]': {
				required: true,
				email: true,
			},
		},
		messages: {
			'login_email[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});

	// Login Password
	$("form[name='login_password']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'login_password[password]': {
				required: true,
			},
		},
		messages: {
			'login_password[password]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
